import React from 'react';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MenuBookIcon from '@mui/icons-material/MenuBook';
export function ProductReveal() {
  const tomo1 = ['Collares de paracord', 'Modelos premium', 'Correas resistentes', 'Sogas artesanales', 'Medidas correctas', 'Terminaciones prolijas', 'Materiales exactos'];
  const tomo2 = ['Cómo calcular precios correctamente', 'Cómo ganar más sin regalar tu trabajo', 'Cómo vender por Instagram y Facebook', 'Cómo conseguir tus primeros clientes', 'Cómo sacar fotos que venden', 'Cómo generar pedidos constantes'];
  const includes = ['Lista completa de materiales', 'Proveedores argentinos recomendados', 'Paso a paso explicado simple', 'Fórmula de precios rentable', 'Estrategias para vender desde casa', 'Diseños modernos y fáciles de hacer'];
  return <section className="py-10 px-4 bg-white" data-id="element-209">
      <div className="max-w-5xl mx-auto" data-id="element-210">
        <div className="text-center mb-8" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-800 mb-3" data-id="element-212">
            🏆 PATITAS EMPRENDEDORAS™
          </h2>
          <p className="text-xl font-bold text-slate-800 mb-2" data-id="element-213">
            TOMO 1 + TOMO 2 + 4 BONOS ESTRATÉGICOS
          </p>
          <p className="text-base text-slate-600 max-w-2xl mx-auto" data-id="element-214">
            Todo explicado paso a paso para que puedas:{' '}
            <span className="font-semibold text-brand-600" data-id="element-215">
              ✔ fabricar ✔ poner precios ✔ vender ✔ y recuperar tu inversión
              rápido
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-216">
          {/* Tomo 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-50 rounded-2xl p-5 border-2 border-brand-200 shadow-lg relative overflow-hidden" data-id="element-217">
            <div className="absolute top-0 right-0 bg-brand-200 text-brand-800 p-3 rounded-bl-2xl" data-id="element-218">
              <MenuBookIcon fontSize="medium" data-id="element-219" />
            </div>
            <h3 className="text-xl font-bold text-brand-900 mb-2 pr-10" data-id="element-220">
              📘 TOMO 1 — FABRICACIÓN ARTESANAL PARA MASCOTAS
            </h3>
            <p className="text-slate-700 mb-3 font-medium text-sm" data-id="element-221">
              Aprendé a crear accesorios modernos y profesionales aunque
              empieces desde cero.
            </p>
            <ul className="space-y-1.5" data-id="element-222">
              {tomo1.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-slate-800 font-medium" data-id="element-223">
                  <CheckCircleIcon className="text-brand-500 mt-0.5" fontSize="small" data-id="element-224" />
                  <span data-id="element-225">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Tomo 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-orange-50 rounded-2xl p-5 border-2 border-orange-200 shadow-lg relative overflow-hidden" data-id="element-226">
            <div className="absolute top-0 right-0 bg-orange-200 text-orange-800 p-3 rounded-bl-2xl" data-id="element-227">
              <MenuBookIcon fontSize="medium" data-id="element-228" />
            </div>
            <h3 className="text-xl font-bold text-orange-900 mb-2 pr-10" data-id="element-229">
              📙 TOMO 2 — NEGOCIO & VENTAS
            </h3>
            <p className="text-slate-700 mb-3 font-medium text-sm" data-id="element-230">
              Cómo convertir tus manualidades en ingresos reales.
            </p>
            <ul className="space-y-1.5" data-id="element-231">
              {tomo2.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-slate-800 font-medium" data-id="element-232">
                  <CheckCircleIcon className="text-orange-500 mt-0.5" fontSize="small" data-id="element-233" />
                  <span data-id="element-234">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* What's included summary */}
        <div className="bg-slate-900 text-white rounded-2xl p-5 md:p-7 shadow-xl" data-id="element-235">
          <h3 className="text-xl font-bold text-center mb-4" data-id="element-236">
            ¿QUÉ INCLUYE CADA TOMO?
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-w-3xl mx-auto" data-id="element-237">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-2 bg-slate-800 p-2.5 rounded-xl text-sm" data-id="element-238">
                <div className="bg-green-500/20 text-green-400 p-1 rounded-full" data-id="element-239">
                  <CheckCircleIcon fontSize="small" data-id="element-240" />
                </div>
                <span className="font-medium" data-id="element-241">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}